import { combineReducers } from "redux";
import responseReducer from "./response/index";
import costantsReducer from "./constants"

export default combineReducers({
  response: responseReducer,
  constants : costantsReducer
});
